// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"c316502f","154":"af1ca517","188":"0379b29b","255":"63a2e189","347":"a2651b9f","647":"af9faecf","997":"8bd30925"}[chunkId] + ".chunk.js";
};